import { render, staticRenderFns } from "./MyIntegral.vue?vue&type=template&id=cf580f2a&scoped=true"
import script from "./MyIntegral.vue?vue&type=script&lang=js"
export * from "./MyIntegral.vue?vue&type=script&lang=js"
import style0 from "./MyIntegral.vue?vue&type=style&index=0&id=cf580f2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf580f2a",
  null
  
)

export default component.exports